import {useAssigneesLiveUpdates} from '../../../hooks/use-assignees-live-updates'
import {useLayoutQuery} from '../../../page-data/loaders/use-layout-query'
import {useAssigneesQuery} from './route-queries'

export function useAssignees() {
  const {data: layoutData} = useLayoutQuery()
  useAssigneesLiveUpdates(layoutData?.aliveChannels)

  return useAssigneesQuery()
}
